import * as React from "react";
import classnames from "classnames";
import { Loader as Icon } from "react-feather";
import { CSSTransition } from "react-transition-group";

interface LoaderProps {
  background?: "primary" | "secondary" | "neutral" | "light" | "panel-light" | "panel-dark" | "none";
  color?: "primary" | "secondary" | "neutral" | "light";
  show: boolean;
}

const Loader: React.FC<LoaderProps> = props => {
  const background = props.background || "panel-dark";
  const color = props.color || "primary";

  return (
    <CSSTransition
      classNames="fade"
      in={props.show}
      timeout={{
        appear: 300,
        enter: 300,
        exit: 200,
      }}
      unmountOnExit
    >
      <div
        className="o-overlay">
        <div
          className={classnames({
            "o-overlay__background": true,
            "bg-primary": background === "primary",
            "bg-secondary": background === "secondary",
            "bg-neutral": background === "neutral",
            "bg-light": background === "light",
            "bg-panel-dark": background === "panel-dark",
            "bg-panel-light": background === "panel-light",
          })}>
        </div>
        <div
          className={classnames({
            "o-overlay__content": true,
            "text-primary": color === "primary",
            "text-secondary": color === "secondary",
            "text-neutral": color === "neutral",
            "text-light": color === "light",
          })}>
          <Icon className="animate-spin" />
        </div>
      </div>
    </CSSTransition>);
};

export default Loader;
